export interface RecentCalculator {
  name: string;
  path: string;
  timestamp: number;
}

const STORAGE_KEY = 'recent_calculators';
const MAX_RECENT = 10;

export function addRecentCalculator(name: string, path: string): void {
  if (typeof window === 'undefined') return;

  try {
    const existing = getRecentCalculators();
    
    // Remove if already exists
    const filtered = existing.filter(calc => calc.path !== path);
    
    // Add to front
    const updated: RecentCalculator[] = [
      { name, path, timestamp: Date.now() },
      ...filtered
    ].slice(0, MAX_RECENT);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Failed to save recent calculator:', error);
  }
}

export function getRecentCalculators(): RecentCalculator[] {
  if (typeof window === 'undefined') return [];

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('Failed to load recent calculators:', error);
    return [];
  }
}